import React from 'react';
import { useState, useEffect } from 'react';
import { Search } from "lucide-react";
import { useParams } from "react-router-dom";
import "../css/SearchBar.css";


function SearchPanel ({
  searchAll, setSearchAll,
  searchNameDesc, setSearchNameDesc,
  searchCategory, setSearchCategory,
  searchMaterial, setSearchMaterial,
  searchStyle, setSearchStyle,
  searchAuthorName, setSearchAuthorName,
  priceMin, setPriceMin,
  priceMax, setPriceMax,
  onSearch,
}) {

const [searchDropdown, setSearchDropdown] = useState (false)

  const closeModal = () => {
    setSearchDropdown(false);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      closeModal();
    }
  };

  const [setlang, setLang] = useState("fa")
  const { lang } = useParams()

  useEffect (() => {
    const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if(lang !== "fa" && lang !== "en") {
      if ( userTimezone === "Asia/Tehran") {
        setLang(`fa`);
      } else {
        setLang(`en`);
      }
    } else {
      setLang(lang)
    }
  }, [lang])


 return (
  <div className="search-panel">
    <div className="search-container">
      <input
        placeholder={setlang === "en" ? "Search" : "جستجو"}
        value={searchAll}
        onChange={e => setSearchAll(e.target.value)}
        className="search-input-all"
      />
      <input
        placeholder={setlang === "en" ? "Name/Description" : "نام اثر "}
        value={searchNameDesc}
        onChange={e => setSearchNameDesc(e.target.value)}
        className="search-input-nadec"
      />
      <input
        placeholder={setlang === "en" ? "Material" : "جنس ساخت"}
        value={searchMaterial}
        onChange={e => setSearchMaterial(e.target.value)}
        className="search-input-mat"
      />
      <input
        placeholder={setlang === "en" ? "Category" : "دسته بندی"}
        value={searchCategory}
        onChange={e => setSearchCategory(e.target.value)}
        className="search-input-cat"
      />
      <input
        placeholder={setlang === "en" ? "Style" : "استایل"}
        value={searchStyle}
        onChange={e => setSearchStyle(e.target.value)}
        className="search-input-sty"
      />
      <input
        placeholder={setlang === "en" ? "Artist" : "صاحب اثر"}
        value={searchAuthorName}
        onChange={e => setSearchAuthorName(e.target.value)}
        className="search-input-art"
      />
      <input
        placeholder={setlang === "en" ? "Min Price" : "قیمت از"}
        type="number"
        value={priceMin}
        onChange={e => setPriceMin(e.target.value)}
        className="price-input"
      />
      <input
        placeholder={setlang === "en" ? "Max Price" : "قیمت تا"}
        type="number"
        value={priceMax}
        onChange={e => setPriceMax(e.target.value)}
        className="price-input"
      />
      <div className='searchdropdown' 
        onClick={() => setSearchDropdown(true)}
      >
        <a title="Search"><Search size={22} /></a>
        {searchDropdown && (
          <div onClick={handleOverlayClick} className='modal-overlay'>
            <div className={setlang === "en" ? "search-cont" : "search-cont-fa"} onClick={e => e.stopPropagation()}>
              <input
                placeholder={setlang === "en" ? "Search" : "جستجو"}
                value={searchAll}
                onChange={e => setSearchAll(e.target.value)}
              />
              <input
                placeholder={setlang === "en" ? "Name/Description" : "نام اثر "}
                value={searchNameDesc}
                onChange={e => setSearchNameDesc(e.target.value)}
              />
              <input
                placeholder={setlang === "en" ? "Category" : "دسته بندی"}
                value={searchCategory}
                onChange={e => setSearchCategory(e.target.value)}
              />
              <input
                placeholder={setlang === "en" ? "Material" : "جنس ساخت"}
                value={searchMaterial}
                onChange={e => setSearchMaterial(e.target.value)}
              />
              <input
                placeholder={setlang === "en" ? "Style" : "استایل"}
                value={searchStyle}
                onChange={e => setSearchStyle(e.target.value)}
              />
              <input
                placeholder={setlang === "en" ? "Artist" : "صاحب اثر"}
                value={searchAuthorName}
                onChange={e => setSearchAuthorName(e.target.value)}
              />
              <input
                placeholder={setlang === "en" ? "Min Price" : "قیمت از"}
                type="number"
                value={priceMin}
                onChange={e => setPriceMin(e.target.value)}
              />
              <input
                placeholder={setlang === "en" ? "Max Price" : "قیمت تا"}
                type="number"
                value={priceMax}
                onChange={e => setPriceMax(e.target.value)}
              />

            <button className="search-button-mini" onClick={closeModal}>
              {setlang === "en" ? "close" : "بستن"}
            </button>
            <button className="search-button-mini" onClick={onSearch}>
              {setlang === "en" ? "Search" : "جستجو"}
            </button>
            </div>
          </div>
        )}
      </div>
      <button className="search-button" onClick={onSearch}>
        Search
      </button>
    </div>
  </div>
);

}

export default SearchPanel;
